<template>

  <div class="Rebate">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>সেৱা সংযোগ অনুমান কেলকুলেটৰ</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title"> সেৱা সংযোগ অনুমান কেলকুলেটৰ</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
           <br>
          <!-- <p style="color:red;">
          We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.
        </p> -->
         <b-row>
               <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 15px;">
                     <span style="font-weight:600" >শ্ৰেণী নিৰ্বাচন কৰক<span class="text-danger">*</span></span>
               </b-col>
               <b-col col cols="12" sm="12" md="8" lg="3" style="padding-top: 10px;">
                 <select name="" id="selectCategory" required style="height:2rem;width:100%" @change="changeSelect()">
                     <option selected  value="0">---Select---</option>
                 </select>
                </b-col>
                <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 15px;">
                      <span style="font-weight:600" id="loadSpan">লোড প্ৰবিষ্ট কৰক <span class="text-danger">*</span></span>
                </b-col>
               <b-col col cols="12" sm="12" md="8" lg="3" style="padding-top: 10px;">
                   <b-form-input type="number" maxlength="12" id="load"  trim required />

                   <span id="loadRange"></span>
               </b-col>
               <!-- <b-col col sm="12" md="3" lg="1" >
                  <b-button @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                    <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
               </b-button> -->
               
          

          </b-row>
          <div id="landOwnerDiv">
            <b-row id ="" >
              <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 15px;">
                    <span style="font-weight:600" >আবেদনকাৰী ভূমিৰ গৰাকী নেকি?  <span class="text-danger">*</span></span>
              </b-col>
              <b-col col cols="12" sm="12" md="8" lg="3" style="padding-top: 10px;">
                <select name="" id="landOwner" required style="height:2rem;width:100%" >
                    <option selected  value="0">---Select---</option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                </select>
              </b-col>
              
              
              <!-- <b-col col sm="12" md="8" lg="1" style="padding-top: 10px !important;">
                  <b-button @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                    <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                  </b-button>
              </b-col> -->
            </b-row>
            
          </div>
          <div id="loadDistance"  style="display:none">
            <b-row id ="" >
                  <b-col col cols="12" sm="12" md="2" lg="2" style="padding-top: 15px; padding-left: 15px;">
                      <span style="font-weight:600" >দূৰত্ব প্ৰবিষ্ট কৰক <span class="text-danger">*</span></span>
                  </b-col>
                  <b-col col cols="12" sm="12" md="3" lg="3"  style="padding-top: 15px;">
                    <b-form-input type="number" id="distload" value="0"  placeholder="" trim required />
                    <span id="distancemesg"> কিলোমিটাৰত 11 কেভি লাইনৰ পৰা দূৰত্ব প্ৰবিষ্ট কৰক</span>  
                </b-col>
                
            </b-row>
         </div>
          <div id="noOfDaysDiv"  style="display:none">
            <b-row id ="" >
                  <b-col col cols="12" sm="12" md="2" lg="2" style="padding-top: 15px;padding-left: 15px;">
                      <span style="font-weight:600" >দিনৰ সংখ্যা <span class="text-danger">*</span></span>
                  </b-col>
                  <b-col col cols="12" sm="12" md="3" lg="3" style="padding-top: 15px;">
                    <b-form-input type="number" id="noOfDays" value="0"  placeholder="" trim required />
                </b-col>
                <!-- <b-col col sm="12" md="3" lg="1" >
                      <b-button @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                        <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                      </b-button>
                </b-col> -->
            </b-row>
         </div>
         <br>
         <div id="calculateButton">
            <b-row>
              <b-col col sm="12" md="3" lg="2" >
                      <!-- <b-button @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                        <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                      </b-button> -->
                      <b-button variant="primary" @click="showDetails()" style="width:100%;">
                        <b-icon icon="file-earmark-check" animation=" "></b-icon> Calculate
                      </b-button>
              </b-col>
            </b-row>
         </div>

      <br>
      <div id="EstimateDetailsDiv" class="hideDetails" style="width:90vw;font-size:0.8rem">
          <span class="heading"> ব্যয়ৰ বিৱৰণ</span>
      <br><br>
      <b-row>
            <b-col col sm="12" md="8" lg="8" style="padding-top: 7px;">
              <b-table  bordered responsive :items="cost" :fields="costFields" style="">
              </b-table>
            </b-col>
        </b-row>
         <span style="color:red; text-transform: capitalize;">
          <!-- ( * The calculated cost shown here is an approximate value, the actual value may differ. )--></span>

        <br> <br> <span id="note1"><!--N.B :  If service line required is excess of 30 meters, service line charges is to be paid as per actual estimate, prepared by
          SDE office--></span> 

    </div>

    <!-- for ht consumers -->
     <div id="estimateHT" style="width:90vw;font-size:0.8rem; display:none; margin-top:-2vw;">
      <!-- <span class="heading"> Cost Details</span> -->
      <br><br>
      <b-row>
            <b-col col sm="12" md="8" lg="8" style="padding-top: 7px; padding-left:0px; padding-right:0px;">
              <!--<b-table  bordered responsive :items="costHT" :fields="costFieldsHT" style="">
               
              </b-table>-->
            </b-col>
        </b-row>
         
        <!-- N.B :  In case the length of service is beyond 50 Meter, 
        consumers shall have to bear the additional cost of construction of 
        11 KV lines under Deposit works head. Per Ckt KM of 11 KV line costs 
        Rs. 26,60,853.00 with SP76 poles and ACSR Reccon Conductor, considering average span of 40 meters. -->
     </div>
    <br>

      </div>
  </b-container>

<br><br>
</b-overlay>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="msg">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
    </b-modal>
  </div>
</template>


<script>

import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
var consNo="";
var sdCode="";
var thColor = '#0288d1';
var categoryList = [];
var catCode = "";
export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {

      costFieldsHT: [
        { key: 'loadHT', label: 'Load (in Kw)',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'costHT', label: 'Cost of Construction of 11/0.44 KV substation (within 50 Meter of existing HT line) with Metering Cost, and Last Span MVCC (Normal)',thStyle: {width: '100vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'itemHT', label: 'Capacity of transformer & Type of metering',thStyle: {width: '40vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }

      ],
      
      costHT : [
        { 
          loadHT: '31 KW to 52 KW', 
          costHT: '₹7,99,738.00', 
          tdstyle:{textAlign: 'center'}, 
          itemHT: '63 KVA  11/0.44 KV Transformer, LT CT metering'
        },
        { 
          loadHT: '53 KW to 80 KW', 
          costHT: '₹9,22,435.00', 
          tdstyle:{textAlign: 'center'}, 
          itemHT: '100 KVA  11/0.44 KV Transformer, LT CT metering'
        },
        { 
          loadHT: '81KW to 200 KW', 
          costHT: '₹18,15,489.00', 
          tdstyle:{textAlign: 'center'}, 
          itemHT: '250 KVA  11/0.44 KV Transformer, HT metering'
        },
        
      ],

      costFields: [
        { key: 'item', label: 'Item',thStyle: {width: '80vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'cost', label: 'Cost',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        // { key: 'costSmart', label: 'Cost (Smart)',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }

      ],
      cost : [

      ],
      show:false
    }
  },
  methods: {
    showDetails() {
      var cat = document.getElementById("selectCategory").value;
      var landOwner = document.getElementById("landOwner").value;
      var distance=document.getElementById("distload").value;
      var load = document.getElementById("load").value;
      console.log("landOwner::"+landOwner);
      console.log("cat::::::"+cat);
      if(cat == '0')
      {
        this.$bvToast.toast('এটা শ্ৰেণী নিৰ্বাচন কৰক', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return
      }

      if(catCode >55 && catCode !=69 && catCode!=75 && catCode!=72){

        if(distance<parseFloat("0.1"))
      {
        this.$bvToast.toast('বৈধ দূৰত্ব প্ৰবিষ্ট কৰক ', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return
      }

      if((load<parseFloat("31")) || (load>parseFloat("150")) )
      {
        this.$bvToast.toast('পৰিসীমাৰ ভিতৰত লোড সুমুৱাওক', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return
      }
        }
      

      
      var noOfDays = document.getElementById("noOfDays").value;
      
      console.log("Days:"+noOfDays)
      if(noOfDays == "")
      {
        this.$bvToast.toast('দিনৰ সংখ্যা প্ৰবিষ্ট কৰক ', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return
      }
      
     
      
      

      var sel = document.getElementById("selectCategory");
     
      var selectText= sel.options[sel.selectedIndex].text;
      var link = categoryList.filter(function(obj) { return obj.category_CODE == selectText; });

      var lowerLoad = parseFloat(link[0].lower_LOAD_KW);
      var higherLoad = parseFloat(link[0].higher_LOAD_KW);
      console.log(lowerLoad+"::::::"+higherLoad)
      //console.log(distance)

      var HtCostConstruction;
      var PerCktKM="2660853.00"

      //newly added for the HT consumer
      if(catCode >55 && catCode !=69 && catCode!=75 && catCode!=72){
        if(landOwner == "0" && catCode!=70){
          this.$bvToast.toast('ভূমিৰ গৰাকী হয় নে নহয় নিৰ্বাচন কৰক !! ', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return
        }
        
        else{
          if(load>=31 && load<=52)
          {
            console.log("load::::::"+load);
            HtCostConstruction = "799738.0";
          }
          else if(load>=53 && load <=80)
          {
            console.log("load::::::"+load);
            HtCostConstruction = "922435.0";

          }
          else if(load>=81 && load<=200)
          {
            console.log("load::::::"+load);
            HtCostConstruction = "1815489.0";

          }

          else{
              this.$bvToast.toast('বৈধ লোড প্ৰবিষ্ট কৰক !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            return
          }
        }
      }
      else if(catCode==70)
      {
        
      }
      else{
        if(load == "" || parseFloat(load)<lowerLoad || parseFloat(load)>higherLoad)
        {
          this.$bvToast.toast('বৈধ লোড প্ৰবিষ্ট কৰক !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return
        }
        // var landOwner = document.getElementById("landOwner").value;
        // console.log("landOwner::"+landOwner);
        // console.log("catCode::"+catCode);

        if((landOwner == "0" ) && (catCode != "54" && catCode != "55" && catCode != 69))
        {
          this.$bvToast.toast('ভূমিৰ গৰাকী হয় নে নহয় নিৰ্বাচন কৰক !! ', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return
        }
      }
      //:::::::::::::::::::::::::::::::

      // if(load == "" || parseFloat(load)<lowerLoad || parseFloat(load)>higherLoad)
      // {
      //   this.$bvToast.toast('Enter Valid Load !', {
      //     title: `Alert`,
      //     variant: 'danger',
      //     solid: true
      //   })
      //   return
      // }
      // var landOwner = document.getElementById("landOwner").value;
      // console.log("landOwner::"+landOwner);
      // console.log("catCode::"+catCode);

      // if((landOwner == "0" ) && (catCode != "54" && catCode != "55" && catCode != 69))
      // {
      //   this.$bvToast.toast('Select if Land Owner or Not !! ', {
      //     title: `Alert`,
      //     variant: 'danger',
      //     solid: true
      //   })
      //   return
      // }
      this.show=true;
      var parent=this;
      axios.post(this.$urlArms+'/RestAPI/nscCalc?cat='+cat+'&load='+load+'&noDays='+noOfDays)
      .then((response) => {
        parent.show=false;
      console.log(response.data);
      var data = response.data;
      var loadSecurity = "";
      if(landOwner == "N")
      {
        loadSecurity = data.otherLoad;
      }
      else {
        loadSecurity = data.normalLoad;
      }
      if(catCode >55 && catCode !=69 && catCode!=75 && catCode!=72 && catCode!=70)
      { var ls=parseFloat(loadSecurity)* parseFloat(load)
        var costofconstruction=parseFloat(HtCostConstruction)+(parseFloat(distance)*parseFloat(PerCktKM))
        var total = parseFloat(ls)+parseFloat(data.meterCost)+parseFloat(data.installationCharge)+parseFloat(costofconstruction);
        
        
        this.cost = [
                    {"item":"Load Security","cost":"₹"+ls.toFixed(2)},
                    {"item":"Meter Cost (without GST)","cost":"₹"+data.meterCost},
                    {"item":"Installation Charge","cost":"₹"+data.installationCharge},
                    {"item":"Cost of Construction", "cost":"₹"+costofconstruction.toFixed(2)},
                    {"item":"Total Cost","cost": "₹"+total.toFixed(2)}
                ]
                
        document.getElementById("estimateHT").style.display = "block";
      }
    else if(catCode==70)
    {
     
      var costofconstruction=parseFloat(HtCostConstruction)+(parseFloat(distance)*parseFloat(PerCktKM)) 
      var total = parseFloat(data.energyCharge)+parseFloat(data.meterSecurityCost)+parseFloat(data.disconnectionCharge)+parseFloat(costofconstruction);
        this.cost = [
                    {"item":"Energy Charge","cost":"₹"+data.energyCharge},
                    {"item":"Meter Security","cost":"₹"+data.meterSecurityCost},
                    {"item":"Disconnection Charge","cost":"₹"+data.disconnectionCharge},
                    {"item":"Cost of Construction", "cost":"₹"+costofconstruction.toFixed(2)},
                    {"item":"Total Cost","cost": "₹"+total.toFixed(2)}
                ]
                
        document.getElementById("estimateHT").style.display = "block";
    }
    else if(catCode == "54" || catCode == "55" || catCode == "69")
        {
          var total = parseFloat(data.energyCharge)+parseFloat(data.meterSecurityCost)+parseFloat(data.disconnectionCharge);
              this.cost = [
                        {"item":"Energy Charge","cost":"₹"+data.energyCharge},
                        {"item":"Meter Security","cost":"₹"+data.meterSecurityCost},
                        {"item":"Disconnection Charge","cost":"₹"+data.disconnectionCharge},
                        {"item":"Total Cost","cost": "₹"+total.toFixed(2)}
                    ]
        }
      else
        {
          var totalCost = parseFloat(loadSecurity)+parseFloat(data.meterCost)+parseFloat(data.installationCharge);
          var totalCostSmart = 0;
          var meterCostSmart = 0;
          if(parseFloat(load)<5)
          {
            meterCostSmart = data.smartSinglePhase;
            totalCostSmart = parseFloat(loadSecurity)+parseFloat(data.smartSinglePhase)+parseFloat(data.installationCharge);
          }
          else
          {
            meterCostSmart = data.smartThreePhase;
            totalCostSmart = parseFloat(loadSecurity)+parseFloat(data.smartThreePhase)+parseFloat(data.installationCharge);
          }
          this.cost = [
                    {"item":"Load Security","cost":"₹"+loadSecurity,"costSmart":"₹"+loadSecurity+" (for postpaid)"},
                    {"item":"Meter Cost (without GST)","cost":"₹"+data.meterCost,"costSmart":"₹"+meterCostSmart},
                    {"item":"Installation Charge","cost":"₹"+data.installationCharge,"costSmart":"₹"+data.installationCharge},
                    {"item":"Total Cost","cost": "₹"+totalCost.toFixed(2),"costSmart":"₹"+totalCostSmart.toFixed(2)}
                   ]
        }

    document.getElementById("EstimateDetailsDiv").classList.add("showDetails");

      })
    },

    changeSelect()
    {
      catCode = document.getElementById("selectCategory").value;
      var sel = document.getElementById("selectCategory");
      var selectText= sel.options[sel.selectedIndex].text;
      

     console.log(selectText)
      if(catCode >55 && catCode !=69 && catCode!=75 && catCode!=72 && catCode!=70){
        // console.log("category code::::::"+catCode);
        document.getElementById("noOfDaysDiv").style.display = "none";
        // document.getElementById("loadRange").style.display = "none";
       // document.getElementById("estimateHT").style.display = "none";
        // document.getElementById('loadSpan').style.display = "none";
        document.getElementById('note1').style.display = "none";
        document.getElementById("landOwnerDiv").style.display="block";
        document.getElementById("loadDistance").style.display="block";
        document.getElementById("loadRange").innerHTML=" (Load Range :31KW - 150KW)";
      }
      else if(catCode == 70){
        console.log("category code::::::"+catCode);

        document.getElementById("noOfDaysDiv").style.display="block";
        document.getElementById("noOfDays").value="";
        document.getElementById("landOwnerDiv").style.display="none";
        document.getElementById('note1').style.display = "none";
        document.getElementById("loadDistance").style.display="block";
        document.getElementById("loadRange").innerHTML=" (Load Range :31KW - 150KW)";
      }
      else{
        var link = categoryList.filter(function(obj) { return obj.category_CODE == selectText; });
        console.log(link);
        document.getElementById("loadRange").innerHTML="(Load Range : "+link[0].lower_LOAD_KW+"KW - "+link[0].higher_LOAD_KW+"KW )"
        console.log("category code::::::"+catCode);
        document.getElementById('EstimateDetailsDiv').style.display = "block";
        document.getElementById('load').style.display= "block";
        document.getElementById("loadRange").style.display = "block";
        document.getElementById('note1').style.display = "block";
        document.getElementById("estimateHT").style.display = "none";
        document.getElementById("loadDistance").style.display="none";
        if(catCode == "54" || catCode == "55" || catCode == 69)
        {
      //  document.getElementById("noOfDays").classList.add("showDetails");
            document.getElementById("noOfDaysDiv").style.display="block";
            document.getElementById("noOfDays").value="";
            document.getElementById("landOwnerDiv").style.display="none";
            document.getElementById("loadDistance").style.display="none";

        }

        else {
        //  document.getElementById("noOfDays").classList.remove("showDetails");
            document.getElementById("noOfDaysDiv").style.display="none";
            document.getElementById("noOfDays").value="0";
            document.getElementById("landOwnerDiv").style.display="block";
            document.getElementById("loadDistance").style.display="none";
        }
        // document.getElementById("loadRange").innerHTML="(Load Range : "+link[0].lower_LOAD_KW+"KW - "+link[0].higher_LOAD_KW+"KW )"
      }
      

      var link = categoryList.filter(function(obj) { return obj.category_CODE == selectText; });
      console.log(link);

        // document.getElementById("loadRange").innerHTML="(Load Range : "+link[0].lower_LOAD_KW+"KW - "+link[0].higher_LOAD_KW+"KW )"
    },

    closeModal(){
      this.$bvModal.hide('model')
    },

  calculateInstallment(n){
  return n;

  }
},
  mounted()
  {
    this.show=true;
    var parent=this;
    axios.post('https://www.apdclrms.com/cbs/RestAPI/crm/getAllCategoryList')
    .then((response) => {
      this.show=false;
      categoryList = response.data;
    //console.log(response.data);
    //document.getElementById("selectDistrict").empty();
     var select = document.getElementById("selectCategory");

     response.data.forEach(function (element, index){
      var optionValue=element.category_CODE.split("-");
      //    console.log(optionValue[0]);
      var  option = document.createElement("option");
        option.text = element.category_CODE;
        option.value = optionValue[0];
        //console.log("option.value[0]::"+option.value)
        if (option.value == "77" || option.value == "76" ){
                    option.style.display = "none";
        }
        select.appendChild(option);
      })

    })
  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">


.paddingRow{
  padding:0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.hideDetails
{
   visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
/*  box-shadow: 2px 2px 10px 2px #bdbdbd; */
  padding-top: 1rem;
  /* margin-right: 1.5rem; */
}
.showDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
@media only screen and (max-width: 414px) {
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
}


</style>
